import 'reflect-metadata';
import { inject, injectable } from 'inversify';
import {
  arsenal_army,
  arsenal_army_all,
  arsenal_army_dto,
  arsenal_army_full,
  arsenal_army_last_update,
} from '@Api';
import { ArsenalArmy, ArsenalArmyVersioning } from '@Models';
import { IMapper } from '../IMapper';
import { TYPES } from '@Types';
import { ArsenalUnitMapper } from './arsenal-unit.mapper';
import { ArsenalStepMapper } from '@Mapper/arsenal/arsenal-step.mapper';

@injectable()
export class ArsenalArmyMapper
  implements IMapper<string, arsenal_army_all, arsenal_army, ArsenalArmy>
{
  @inject(TYPES.Mapper.ArsenalUnitMapper)
  private _unitMapper!: ArsenalUnitMapper;

  @inject(TYPES.Mapper.ArsenalStepMapper)
  private _arsenalStepMapper!: ArsenalStepMapper;

  public mapAll(item: arsenal_army_all): ArsenalArmy {
    return {
      id: item.id,
      name: item.name,
      armyCategoryId: item.army_category_id,
      updatedAt: item.updated_at,
      units: [],
      logo: item.medium_logo,
      largeLogo: item.large_logo,
      steps: item.steps.map((s) => this._arsenalStepMapper.map(s)),
    } satisfies ArsenalArmy as ArsenalArmy;
  }

  public mapFull(item: arsenal_army_full): ArsenalArmy {
    return {
      id: item.id,
      name: item.name,
      armyCategoryId: item.army_category_id,
      updatedAt: item.updated_at,
      units: [],
      logo: item.medium_logo,
      largeLogo: item.large_logo,
      steps: item.steps.map((s) => this._arsenalStepMapper.map(s)),
    } satisfies ArsenalArmy as ArsenalArmy;
  }

  public map(item: arsenal_army): ArsenalArmy {
    return {
      id: item.id,
      name: item.name,
      armyCategoryId: item.army_category_id,
      updatedAt: item.updated_at,
      logo: item.medium_logo,
      largeLogo: item.large_logo,
      units:
        item.units
          ?.map((u) => this._unitMapper.map(u))
          ?.sort((a, b) => a.position - b.position) ?? [],
      steps: item.steps.map((s) => this._arsenalStepMapper.map(s)),
    } satisfies ArsenalArmy as ArsenalArmy;
  }

  public mapDto(item: ArsenalArmy): arsenal_army_dto {
    return {
      id: item.id != '' ? item.id : null,
      name: item.name,
      army_category_id: item.armyCategoryId,
    } satisfies arsenal_army_dto as arsenal_army_dto;
  }

  public mapVersioning(item: arsenal_army_last_update): ArsenalArmyVersioning {
    return {
      id: item.id,
      name: item.name,
      updatedAt: item.updated_at,
    } satisfies ArsenalArmyVersioning as ArsenalArmyVersioning;
  }
}
